export default "__VITE_ASSET__dJnF_Xmt__"